import PlainModal, { PlainModalContent } from 'app/common/ui-next/plain-modal'

import Loader from './loading'
import styles from './loading-modal.module.scss';


type Props = {
  isOpen?: boolean,
}

const LoadingModal = ({ isOpen = true }: Props) => (
  isOpen
    ? <PlainModal show={isOpen} className={styles.root}>
      <PlainModalContent>
        <Loader />
      </PlainModalContent>
    </PlainModal>
    : null
)

export default LoadingModal
